import classNames from 'classnames/bind';
import React from 'react';
import {
  Button, Col, ListGroup, Row,
} from 'react-bootstrap';
import { AutoAchievement } from '../../../../../../dorian-shared/types/branch/AnswerStep';
import styles from '../Steps.scss';
import { AnswerAutoAchievementItem } from './AnswerAutoAchievementItem';
import { AutoAchievementTooltip } from './AutoAchievementTooltip';

const cs = classNames.bind(styles);

export interface AutoAchievementProps {
  values: AutoAchievement[] | undefined;
  onChange: (data: AutoAchievement[]) => void;
  answerIndex: number;
  activeSteps: string;
  activeStepsFunc: (step: string) => void;
  stepIndex: number;
  show: boolean;
}

export function AnswerAutoAchievement(props: AutoAchievementProps) {
  const {
    values = [],
    onChange,
    answerIndex,
    activeSteps,
    activeStepsFunc,
    stepIndex,
    show,
  } = props;

  const handleItemAdd = () => {
    const newValue: AutoAchievement = 0;
    onChange([...values, newValue]);
  };

  const handleItemRemove = (index: number) => {
    const newValues = values.filter((_, i) => i !== index);
    onChange(newValues);
  };

  const handleItemChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const newValue = [...values];
    newValue[index] = event.target.value as any;
    onChange(newValue);
  };

  return (
    <Row className={cs('answerStepAdditionalDataContainer', show ? 'd-block' : 'd-none')}>
      <Col
        md={12}
        className={cs('mx-0 pb-0 pt-2 border-top')}
      >
        <Row>
          <Col sm="auto" className="d-flex align-items-center">
            <h6 style={{ position: 'relative' }}>
              Auto Achieve
              <AutoAchievementTooltip id={`auto_achieve-tooltip_${stepIndex}_${answerIndex}`} />
            </h6>
          </Col>
          <Col sm="auto">
            <Button size="sm" variant="secondary" className="ml-3" onClick={handleItemAdd}>
              + Add Achievement
            </Button>
          </Col>
        </Row>
        <ListGroup as="ul" variant="flush" className={cs('my-1', 'mx-1', 'px-0', 'branchesList')}>
          {
              values.map((value, i) => (
                <AnswerAutoAchievementItem
                  key={i}
                  index={i}
                  answerIndex={answerIndex}
                  stepIndex={stepIndex}
                  activeSteps={activeSteps}
                  activeStepsFunc={activeStepsFunc}
                  value={value}
                  onDelete={() => handleItemRemove(i)}
                  onChange={(e) => handleItemChange(e, i)}
                />
              ))
            }
        </ListGroup>
      </Col>
    </Row>
  );
}
